var link_viewer_wrapper_default = {
  "anchor": "SxYSs",
  "link": "SaTfh"
};
export {
  link_viewer_wrapper_default as default
};
//# sourceMappingURL=link-viewer-wrapper-scss.js.map
